<template>
    <div>
        <section class="ptb-100 overflow-hidden hero-equal-height bg-image">
            <div class="background-image-wraper"
                style="background-color: #f1f5fa; opacity: .5;"></div>
            <div class="container">
                <div class="row align-items-center justify-content-lg-between justify-content-md-center justify-content-sm-center">
                    <div class="col-md-12 col-lg-6">
                        <div class="hero-slider-content py-5">
                        <!-- <div class="headline mb-4">
                                <p class="mb-0"><i class="fas fa-lock rounded-circle mr-2"></i> <span class="font-weight-bold">Securité assurée</span></p>
                            </div> -->
                            <h1 style="color: #313A58;">
                                La gestion de contenu d'entreprise nouvelle génération.
                            </h1>
                            <p style="font-size: 16px">
                                FDSU Docs est une plateforme sécurisée, ultra-intuitive,
                                de gestion de contenu, de partage de documents, de collaboration et automatisation
                                de vos processus métiers.
                            </p>

                            <div class="action-btns mt-4">
                                <!-- <a href="/register" class="btn btn-brand-03 btn-lg">
                                    Essai Gratuit
                                </a> -->
                                <a href="/register" class="btn btn-brand-03 btn-lg" @click.prevent="showModal = true">
                                    Découvrir FDSU Docs
                                    <!-- <i class="fa fa-play ml-2"></i> -->
                                </a>
                                <b-modal id="modal-lg" v-model="showModal" size="lg" centered hide-header hide-footer
                                    :body-class="['video-modal-body']">
                                    <div class="embed-responsive embed-responsive-16by9">
                                        <iframe src="https://player.vimeo.com/video/751643551?h=b433060eae" frameborder="0"></iframe>
                                    </div>
                                </b-modal>
                            </div>
                            
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12 col-lg-6">
                        <div class="img-wrap">
                            <LottieAnimation
                            ref="anim"
                            :animationData="require('@/assets/json/home.json')"
                            loop
                            />
                        </div>
                    </div>
                </div>
                <!--end of row-->
            </div>
            <!--end of container-->
        </section>
        <!-- <section class="appliction-hosting mt-n-90" style="background: white">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="application-hosting-wrap">
                            <ul class="app-list">
                                <li><a href="#fonction" class="bg-white shadow text-dark"><img src="@/assets/icons/idea.png" alt="icon"> <span>Fonctionnalités</span></a></li>
                                <li><a href="#secur" class="bg-white shadow text-dark"><img src="@/assets/icons/locked.png" alt="icon"> <span>Securité</span></a></li>
                                <li><a href="#avant" class="bg-white shadow text-dark"><img src="@/assets/icons/gift-box.png" alt="icon"> <span>Avantages</span></a></li>
                                <li><a href="#Prix" class="bg-white shadow text-dark"><img src="@/assets/icons/star.png" alt="icon"> <span>Nos tarifs</span></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->
        <!--our team section start-->
        <section class="client-section mt-4" style="background: white">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-8">
                        <div class="section-heading text-center mt-4">
                            <h3 style="color: #313A58;">
                                Plusieurs entreprises à travers le monde utilisent FDSU Docs au quotidien
                            </h3>
                        </div>
                    </div>
                </div>
                <div class="align-items-center">
                    <div class="col-md-12">
                        <carousel :autoplay="true" :nav="false" :items="5" :margin="60" :loop="true" :dots="false">
                            <img src="@/assets/images/partner/arptc.png" alt="client logo" class="customer-logo">
                            <img src="@/assets/images/partner/edoc.png" alt="client logo" class="customer-logo">
                            <img src="@/assets/images/partner/Ministere_PTNTIC.png" alt="client logo" class="customer-logo">
                            <img src="@/assets/images/partner/SCHOOLAP.png" alt="client logo" class="customer-logo">
                            <img src="@/assets/images/partner/ISHANGO.png" alt="client logo" class="customer-logo">
                            <img src="@/assets/images/partner/microsoft_365.png" alt="client logo" class="customer-logo">
                        </carousel>
                    </div>
                </div>
            </div>
        </section>
        <!--our team section end-->
    </div>
</template>
<script>

import LottieAnimation from 'lottie-web-vue'
import carousel from 'vue-owl-carousel'
export default {
    components: {
        LottieAnimation,
        carousel,
    },
    data() {
        return {
            showModal: false,
        }
    },
}
</script>